import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
// import { AuthService } from '../auth/auth.service';
// import { JwtHelperService } from '@auth0/angular-jwt';

@Injectable()
 export class AuthGuard {
    // export class AuthGuard implements CanActivate {
//     jwtHelper: JwtHelperService = new JwtHelperService();
//     isTokenExpired: boolean;
//     constructor(private localStorage: any,
//                 private router: Router) {
//         this.isTokenExpired = false;
//     }
//     public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
//         const token = this.localStorage.getItem('token');
//         this.isTokenExpired = token ? this.jwtHelper.isTokenExpired(token) : false;
//         if (this.isTokenExpired) {
//             this.localStorage.clear();
//             this.router.navigate(['']);
//             return false;
//         } else {
//             return true;
//         }
//     }
}
